import path from 'node:path';
import type { SymbolTag } from './types.js';
import { isModulePathSpecifier, resolveModuleImportPath } from './resolve-module-import-path.js';

export function enrichTagsWithModulePaths(
  tags: readonly SymbolTag[],
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
): SymbolTag[] {
  return tags.map((tag) => {
    if (tag.kind !== 'module' || tag.role !== 'ref' || !isModulePathSpecifier(tag.name)) {
      return tag;
    }
    const resolved = resolveModuleImportPath(filePath, tag.name, workspaceFiles);
    if (!resolved) return tag;
    return { ...tag, navTargetPath: resolved };
  });
}

export function workspaceFilesFromCollected(collected: ReadonlyArray<{ relPath: string }>): Set<string> {
  return new Set(collected.map((entry) => entry.relPath.replace(/\\/g, '/')));
}

export function workspaceFilesFromParent(parentPath: string, relPaths: readonly string[]): Set<string> {
  return new Set(relPaths.map((rel) => path.posix.normalize(rel.replace(/\\/g, '/'))));
}
